import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  constructor(private http: HttpClient) { }

  getOrganizations(): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations`;
    return this.http.get(url);
  }
  getOrganization(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/${id}`;
    return this.http.get(url);
  }

  deleteOrganization(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/${id}`;
    return this.http.delete(url);
  }

  saveOrganization(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations`;
    if (value.id) {
      return this.http.post(url, value);
    } else {
      return this.http.put(url, value);
    }
  }

  getBusinessUnits(): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/business-units-in-use`;
    return this.http.get(url);
  }

  getOrganogram(value: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/location-organogram/${value}`;
    return this.http.get(url);
  }

  getTerritories(): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/my-territories`;
    return this.http.get(url);
  }

  changeParentLocation(updateParams: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/locations/change-parent`;
    return this.http.post(url, updateParams);
  }

  deleteLocation(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/locations/${id}`;
    return this.http.delete(url);
  }

  createAccountAndSendWelcomeEmail(locationIdList: Array<string>): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/locations/create-account`;
    return this.http.post(url, locationIdList);
  }

  saveLocation(loc: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/save-location`;
    return this.http.put(url, loc);
  }

  vacatePosition(obj: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/vacate-location-position`;
    return this.http.post(url, obj);
  }

  deleteLocationPosition(locationId: string, positionIndex: number): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/delete-location-position/${locationId}/${positionIndex}`;
    return this.http.delete(url);
  }

  getChildLocations(id): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/child-locations/${id}`;
    return this.http.get(url);
  }

  splitLocation(splitLocationDetails: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/split-location`;
    return this.http.post(url, splitLocationDetails);
  }

  createLocationPosition(obj: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/location-position`;
    return this.http.post(url, obj);
  }

  saveLocationDetails(value: any, locationId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/location-details/${locationId}`;
    return this.http.post(url, value);
  }

  mergeTerritory(mergeObj: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/merge-locations`;
    return this.http.post(url, mergeObj);
  }

  getAseEnrolmentStatus(): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/ase-enrollment`;
    return this.http.get(url);
  }
}
